import React from 'react';
import PropTypes from 'prop-types';
import { SubmissionGroups } from '../helpers/submissionConfig';

const FormNavigationStep = ({ icon, label, active }) => (
  <div className={`c-form-navigation__step ${active ? 'c-form-navigation__step--active' : ''}`}>
    <div className='c-form-navigation__icon'>{icon}</div>
    <div className='c-form-navigation__label'>{label}</div>
  </div>
);

FormNavigationStep.propTypes = {
  icon: PropTypes.element,
  label: PropTypes.string,
  active: PropTypes.bool
};

const nthGroup = currentStepIndex => {
  let maxStepIndex = -1;
  let matchingGroupIndex = -1;
  do {
    matchingGroupIndex += 1;
    maxStepIndex += SubmissionGroups[matchingGroupIndex].spanSteps;
  } while (currentStepIndex > maxStepIndex);
  return matchingGroupIndex;
};

const FormNavigation = ({ index }) => {
  const currentGroupIndex = nthGroup(index);
  return (
    <div className='c-form-navigation'>
      <div className='c-form-navigation__shifter' style={{ left: `${-150 * currentGroupIndex}px` }}>
        {SubmissionGroups.map((group, i) => (
          <FormNavigationStep
            key={i}
            label={group.title}
            active={currentGroupIndex === i}
            icon={group.icon}
          />
        ))}
      </div>
    </div>
  );
};

FormNavigation.propTypes = {
  index: PropTypes.number.isRequired
};

export default FormNavigation;
